// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".cross-button[data-v-12ababba]{display:flex;width:1.25rem;height:1.25rem}.cross-button__img[data-v-12ababba]{margin:auto}", ""]);
// Exports
module.exports = exports;
